angular.module('NumbersEditor')
    .controller('NewAdhocController', [
        '$scope', 'NewAdhocGameFactory', 'GameFactory', 'appInfoFactory', '$location', '$rootScope', '$routeParams', '$dialogs', '$document', 'newAdhocService', 'gameService',
        function ($scope, newAdhocGameFactory, gameFactory, appInfoFactory, $location, $rootScope, $routeParams, $dialogs, $document, newAdhocService, gameService) {

            init();

            $scope.isSubmitting = false;

            function init() {
                $rootScope.SetAppTitle("New", "New Adhoc Game");
                getNewAdhocGame();
                setMinMaxDates();
            };

            function getNewAdhocGame() {
                newAdhocService.getNewAdhocGame()
                    .then(function (newAdhoc) {
                        newAdhoc.StartDate = new Date(newAdhoc.StartDate);
                        newAdhoc.IsAdhoc = 'Y';
                        newAdhoc.Events = [];
                        newAdhoc.Events.push(new Object({ EventDisplayTime: '' }));
                        $scope.NewAdhoc = newAdhoc;
                        gameService.setDatePicker($scope);
                    })
                    .catch(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            };

            function setMinMaxDates() {
                appInfoFactory.getDateTime()
                    .success(function (dateTime) {
                        var today = new Date(JSON.parse(dateTime));
                        var maxDate = new Date(today.setMonth(today.getMonth() + 3));
                        $scope.maxDate = new Date(maxDate.setDate(today.getDate() - 1));
                    }).error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            }

            $scope.AddAdhocEvent = function () {
                $scope.NewAdhoc.Events.push(new Object({ EventDisplayTime: '' }));
            }

            $scope.DeleteAdhocEvent = function (index) {
                if ($scope.NewAdhoc.Events.length === 1) {
                    $.message('You must have at least 1 Event', MessageType.Error);
                    return;
                }
                $scope.NewAdhoc.Events.splice(index, 1);
            }

            $scope.SaveAdhocGame = function () {
                var game = $scope.NewAdhoc;
                var eDate = new Date(game.StartDate);
                eDate.setHours("12");
                game.StartDate = eDate;

                if (!saveValidate(game)) {
                    return;
                }

                updateEventTimes(game);

                $scope.isSubmitting = true;
                gameFactory.insertGame(game)
                    .success(function (gameid) {
                        $.message(MessageText.GameSuccessfullyCreated, MessageType.Success);
                        $location.path('game/' + gameid.toString()).search({ sportCode: $scope.NewAdhoc.SportCode.toString(), startDate: $scope.NewAdhoc.StartDate.toISOString() });
                    })
                    .error(function (error) {
                        $.message(error.Message, MessageType.Error);
                        $scope.isSubmitting = false;
                    });
            };

            function saveValidate(game) {
                var validationPassed = true;
                $.each(game.Events, function (key, event) {
                    if (event.EventDisplayTime === '') {
                        $.message('Not all the events have a time', MessageType.Error);
                        validationPassed = false;
                    }
                });
                return validationPassed;
            }

            function updateEventTimes(game) {
                var events = []
                $.each(game.Events, function (key, event) {
                    var eTime = new Date(1970, 0, 1);
                    eTime.setHours(event.EventDisplayTime.split(":")[0]);
                    eTime.setMinutes(event.EventDisplayTime.split(":")[1]);
                    eTime.setSeconds("00");
                    var x = convertUtcDateToLocalDate(eTime);
                    events.push(new Object({ EventDisplayTime: event.EventDisplayTime, EventTime: x.getTime() }));
                });
                game.Events = events;
            }

            function convertUtcDateToLocalDate(date) {
                var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

                var offset = date.getTimezoneOffset() / 60;
                var hours = date.getHours();

                newDate.setHours(hours - offset);

                return newDate;
            };

            $scope.$watch('NewAdhoc.StartDate', function () {
                $scope.opened = false;
            });

            $document.bind('keypress', function ($event) {
                if ($event.which === 13) {
                    $("#btnstartdate").click();
                }
            });

            // disabled the Christmas day in the calendar
            $scope.disabled = function (date, mode) {
                if (date.getMonth() == 11 && date.getDate() == "25") return true;
                else return false;

            };

            $scope.closemodal = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.opened = false;
            };

            $scope.open = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.opened = true;
            };

            $document.bind('click', function ($event) {
                $scope.opened = false;
            });

            $scope.dateSelection = function () {
                alert('selection');
            }
        }
    ]);